/**
 * Validation registry:
 * - type → intrinsic rules only (email format; never required)
 * - field.validation → explicit rules (required, minLength, maxLength)
 */

import type { FormField } from '../schema/types';
import type { ValidationField } from '../helpers/form';

type IntrinsicBuilder = (field: FormField) => ValidationField;

/** Intrinsic by type — Type ≠ required */
const intrinsicBuilders: Record<string, IntrinsicBuilder> = {
  text: () => ({}),
  email: () => ({ email: true }),
  phone: () => ({}),
  textarea: () => ({}),
};

export function buildFieldValidation(field: FormField): ValidationField {
  const intrinsic = (intrinsicBuilders[field.type] ?? (() => ({})))(field);
  const explicit = field.validation ?? {};

  return {
    ...intrinsic,
    required: explicit.required ?? false,
    minLength: explicit.minLength,
    maxLength: explicit.maxLength,
    // intrinsic email format from type: 'email' — not from schema validation.email
    email: intrinsic.email === true,
  };
}

export function buildValidationConfig(
  fields: FormField[],
): Record<string, ValidationField> {
  return fields.reduce(
    (acc, field) => {
      acc[field.name] = buildFieldValidation(field);
      return acc;
    },
    {} as Record<string, ValidationField>,
  );
}

export function registerIntrinsicValidation(
  fieldType: string,
  builder: IntrinsicBuilder,
): void {
  intrinsicBuilders[fieldType] = builder;
}
